// Author Shi Wen Long
// Date 2023-09-06 15:54:01

class SithMesStoolDeliverList {
    constructor({
                    id = null,
                    taskCode = '',
                    poNumber = '',
                    itemNumber = '',
                    material = '',
                    materialDescription = '',
                    unit = '',
                    quantity = '',
                    sentQuantity = '',
                    leftQuantity = '',
                    type = '',
                    pictureNum = '',
                    standard = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.taskCode = taskCode;
        this.poNumber = poNumber;
        this.itemNumber = itemNumber;
        this.material = material;
        this.materialDescription = materialDescription;
        this.unit = unit;
        this.quantity = quantity;
        this.sentQuantity = sentQuantity;
        this.leftQuantity = leftQuantity;
        this.type = type;
        this.pictureNum = pictureNum;
        this.standard = standard;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesStoolDeliverList();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'taskCode',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.taskCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poNumber',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.poNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemNumber',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.itemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorCode',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.vendorCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameZh',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.vendorNameZh',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameEn',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.vendorNameEn',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'material',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.material',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unit',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.unit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sentQuantity',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.sentQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'leftQuantity',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.leftQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'type',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.type',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'pictureNum',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.pictureNum',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'standard',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.standard',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolDeliverList.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    generatedTaskFilter: '',
    taskCodeFilter: '',
    poNumberFilter: '',
    itemNumberFilter: '',
    vendorCodeFilter: '',
    vendorNameZhFilter: '',
    vendorNameEnFilter: '',
    materialFilter: '',
    materialDescriptionFilter: '',
    unitFilter: '',
    quantityFilter: '',
    sentQuantityFilter: '',
    leftQuantityFilter: '',
    typeFilter: '',
    pictureNumFilter: '',
    standardFilter: '',
    vendorAccountNumberFilter: '',
    projectCodeFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'generatedTaskFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.generatedTask',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskCodeFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.taskCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumberFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.poNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemNumberFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.itemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorCodeFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.vendorCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZhFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.vendorNameZh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameEnFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.vendorNameEn',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescriptionFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.materialDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unitFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.unit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sentQuantityFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.sentQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'leftQuantityFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.leftQuantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'typeFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.type',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pictureNumFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.pictureNum',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'standardFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.standard',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolDeliverList.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'taskCode',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.taskCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poNumber',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.poNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemNumber',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.itemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.material',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.materialDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unit',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.unit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sentQuantity',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.sentQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'leftQuantity',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.leftQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'type',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolDeliverList.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesStoolDeliverList, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}